import { render, staticRenderFns } from "./form.vue?vue&type=template&id=841bce7a&"
import script from "./form.vue?vue&type=script&lang=js&"
export * from "./form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\00_GIT\\hotel\\hotel-front-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('841bce7a')) {
      api.createRecord('841bce7a', component.options)
    } else {
      api.reload('841bce7a', component.options)
    }
    module.hot.accept("./form.vue?vue&type=template&id=841bce7a&", function () {
      api.rerender('841bce7a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/activity/scanCode/form.vue"
export default component.exports